export default {

  // Chargement page
  loading: false
}



// WEBPACK FOOTER //
// ./src/store/state.js